enum YesNo {
    'Y' = "Yes",
    'N' = "No",
}

export default YesNo;
